export default function WhatIsExpeditingSection() {
  return (
    <section id="what-is-it" className="py-16 md:py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-8 text-center">
          What Is a Passport Expediting Service — And Why Does the Choice Matter?
        </h2>
        <div className="max-w-4xl mx-auto space-y-5 text-base md:text-lg text-gray-700 leading-relaxed">
          <p>
            A <strong className="text-[#1A365D]">passport expediting service</strong> is a private company registered with the U.S. Department of State to submit passport applications directly to federal passport agencies on behalf of customers. Not every company that calls itself a passport expediter is actually registered — and not every registered expediter is a direct courier.
          </p>
          <p>
            The distinction matters. Some "expediting services" are <strong className="text-[#1A365D]">resellers</strong> — they charge a fee and hand your application to an actual registered courier like Fast Passport Center, so you pay twice. Others operate through retail networks like FedEx Office or Staples, adding markup and extra handling.
          </p>
          <p>
            Fast Passport Center is a <strong className="text-[#1A365D]">registered direct courier</strong>. No middleman. No retail markup. Direct courier service at direct prices — 20–80% less than most retail passport counters.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          <div className="bg-[#F0F4F8] rounded-lg p-6 text-center border border-[#D0D7E2]">
            <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-[#1A365D]">
              <i className="ri-government-fill text-xl text-[#C0C8D6]"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-base mb-2">Registered Courier</h3>
            <p className="text-sm text-gray-600">We are the actual registered courier with daily agency access. Not a middleman, not a reseller.</p>
          </div>
          <div className="bg-[#F0F4F8] rounded-lg p-6 text-center border border-[#D0D7E2]">
            <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-[#1A365D]">
              <i className="ri-scales-3-line text-xl text-[#C0C8D6]"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-base mb-2">Reseller</h3>
            <p className="text-sm text-gray-600">Markets passport services but hands your application to a real courier — adding a markup you pay.</p>
          </div>
          <div className="bg-[#F0F4F8] rounded-lg p-6 text-center border border-[#D0D7E2]">
            <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-full bg-[#1A365D]">
              <i className="ri-store-3-line text-xl text-[#C0C8D6]"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-base mb-2">Retail Counter</h3>
            <p className="text-sm text-gray-600">FedEx Office, Staples, etc. — they charge their fee and hand it to a courier. You pay both markups.</p>
          </div>
        </div>
      </div>
    </section>
  );
}